import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const ReportDetailsPage = lazy(
  () => import('./pages/reportList/ReportDetails.page'),
);

const ReportListPage = lazy(() => import('./pages/reportList/ReportList.page'));
const ScheduledReportListPage = lazy(
  () => import('./pages/scheduledReport/ScheduledReportList.page'),
);

export const ReportsRoutes = () => {
  return (
    <Routes>
      <Route index element={<ReportListPage />} />
      <Route path="scheduled" element={<ScheduledReportListPage />} />
      <Route path=":reportId" element={<ReportDetailsPage />} />
    </Routes>
  );
};
